import * as coreCommon from 'assets/core/js/common'
import ImagesSlider from 'assets/core/js/module/imagesSlider'
import readMoreText from 'assets/core/js/module/readMoreText'

const initPropertiesSliders = function (): void {
  document.querySelectorAll<HTMLElement>('.aquatic__wrapper .swiper:not(.swiper-initialized)').forEach(function (el) {
    ImagesSlider(el, {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: function (_: undefined, current: number) {
          return `${current}/${el.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)').length}`
        },
      },
      spaceBetween: 16,
    })
  })

  document.querySelectorAll<HTMLElement>('.product__properties-slider .swiper:not(.swiper-initialized)').forEach(function (el) {
    ImagesSlider(el, {
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'custom',
        renderCustom: function (_: undefined, current: number, total: number) {
          return `${current}/${total}`
        },
      },
      spaceBetween: 16,
    })
  })
}

document.querySelectorAll<HTMLElement>('.product__section .dca-collapsible-block__toggle[data-url]').forEach(function (el) {
  el.addEventListener(
    'click',
    function (this: HTMLElement) {
      const url = this.getAttribute('data-url')

      if (!url) {
        return
      }

      const sectionEl = this.closest('.product__section')

      if (!sectionEl) {
        return
      }

      const toggleEl = sectionEl.querySelector(`.dca-collapsible-block__content[data-toggle="${this.getAttribute('data-target')}"]`)

      if (!toggleEl) {
        return
      }

      const xhrRequest = coreCommon.createXhr('GET', url)

      xhrRequest.onreadystatechange = () => {
        if (xhrRequest.readyState === XMLHttpRequest.DONE && xhrRequest.status === 200 && xhrRequest.response) {
          toggleEl.innerHTML = xhrRequest.response as string
          readMoreText(sectionEl)
          initPropertiesSliders()
          this.removeAttribute('data-url')
        }
      }

      xhrRequest.send()
    },
    {
      once: true,
    }
  )
})

export default function (): void {
  initPropertiesSliders()
}
